/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Smarts
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import SmartsEntry from './SmartsEntry'
// import { SmartsEntry as SmartsService } from './SmartsEntry'
// import * as SmartsService from './SmartsEntry'

class SmartsService extends SmartsEntry {
	constructor(options) {
		super(options)
	}
}

export {
	SmartsService
}
